import React from 'react';

const GenerateButton = ({ onClick }) => {
  return <button onClick={onClick}>Generate PDF</button>;
};

export default GenerateButton;
